var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"toast",style:({ background: _vm.getToastColor })},[_c('div',{staticClass:"toast__holder"},[_c('span',{staticClass:"toast__message",domProps:{"innerHTML":_vm._s(_vm.getToastMessage)}}),_c('div',{staticClass:"toast__button",domProps:{"innerHTML":_vm._s(_vm.getToastButton)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }